import { render, staticRenderFns } from "./BiochemicalReagent.vue?vue&type=template&id=13d34681&scoped=true"
import script from "./BiochemicalReagent.vue?vue&type=script&lang=js"
export * from "./BiochemicalReagent.vue?vue&type=script&lang=js"
import style0 from "./BiochemicalReagent.vue?vue&type=style&index=0&id=13d34681&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d34681",
  null
  
)

export default component.exports